var CommonBaseView, HoldTimeDisplayTemplate, HoldTimeView, SharedSpinnerView, SupportUtils,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

HoldTimeDisplayTemplate = require('../../../../hold_time_display.html.mustache');

CommonBaseView = require("../../common/views/common_base_view");

SharedSpinnerView = require("../../../../../shared/frontend/views/spinner_view");

SupportUtils = require("../../../helpers/utils");

HoldTimeView = (function(superClass) {
  extend(HoldTimeView, superClass);

  function HoldTimeView() {
    this.displayHoldTime = bind(this.displayHoldTime, this);
    return HoldTimeView.__super__.constructor.apply(this, arguments);
  }

  HoldTimeView.prototype.initialize = function(params) {
    this.template = HoldTimeDisplayTemplate;
    this.spinnerView = new SharedSpinnerView();
    return this.model = params.model;
  };

  HoldTimeView.prototype.render = function() {
    this.model.getWaitTimeInformation(I18n.locale, this.displayHoldTime);
    return this.showLoadingSpinner('#call-back-spinner', '40px');
  };

  HoldTimeView.prototype.toHash = function(waitTime) {
    return {
      holdTime: waitTime
    };
  };

  HoldTimeView.prototype.displayHoldTime = function(waitTime) {
    this.hideLoadingSpinner('#call-back-spinner');
    this.$el.empty();
    this.$el.append(toHtml(this.template, this.toHash(waitTime), this.I18nScope));
    return $('#call-back-hold-time').append(this.$el);
  };

  HoldTimeView.prototype.updateHoldTime = function(locale) {
    $("#call-back-hold-time").empty();
    this.showLoadingSpinner('#call-back-spinner', '40px');
    return this.model.getWaitTimeInformation(locale, this.displayHoldTime);
  };

  HoldTimeView.prototype.hideLoadingSpinner = function(element) {
    $(element).empty();
    return window.hideDOMElems($(element));
  };

  HoldTimeView.prototype.showLoadingSpinner = function(element, size) {
    window.showDOMElems($(element));
    return SupportUtils.showLoading($(element), size);
  };

  return HoldTimeView;

})(CommonBaseView);

module.exports = HoldTimeView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9VUy9ob2xkX3RpbWVfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9lbWFpbF9mb3JtL1VTL2hvbGRfdGltZV92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHNGQUFBO0VBQUE7Ozs7QUFBQSx1QkFBQSxHQUEwQixPQUFBLENBQVEsNkNBQVI7O0FBQzFCLGNBQUEsR0FBaUIsT0FBQSxDQUFRLHFDQUFSOztBQUNqQixpQkFBQSxHQUFvQixPQUFBLENBQVEsbURBQVI7O0FBQ3BCLFlBQUEsR0FBZSxPQUFBLENBQVEsd0JBQVI7O0FBRVQ7Ozs7Ozs7O3lCQUVKLFVBQUEsR0FBWSxTQUFDLE1BQUQ7SUFDVixJQUFDLENBQUEsUUFBRCxHQUFZO0lBQ1osSUFBQyxDQUFBLFdBQUQsR0FBZSxJQUFJLGlCQUFKLENBQUE7V0FDZixJQUFDLENBQUEsS0FBRCxHQUFTLE1BQU0sQ0FBQztFQUhOOzt5QkFLWixNQUFBLEdBQVEsU0FBQTtJQUNOLElBQUMsQ0FBQSxLQUFLLENBQUMsc0JBQVAsQ0FBOEIsSUFBSSxDQUFDLE1BQW5DLEVBQTJDLElBQUMsQ0FBQSxlQUE1QztXQUNBLElBQUMsQ0FBQSxrQkFBRCxDQUFvQixvQkFBcEIsRUFBMEMsTUFBMUM7RUFGTTs7eUJBSVIsTUFBQSxHQUFPLFNBQUMsUUFBRDtXQUNMO01BQUEsUUFBQSxFQUFVLFFBQVY7O0VBREs7O3lCQUdQLGVBQUEsR0FBaUIsU0FBQyxRQUFEO0lBQ2YsSUFBQyxDQUFBLGtCQUFELENBQW9CLG9CQUFwQjtJQUNBLElBQUMsQ0FBQSxHQUFHLENBQUMsS0FBTCxDQUFBO0lBQ0EsSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksTUFBQSxDQUFPLElBQUMsQ0FBQSxRQUFSLEVBQWtCLElBQUMsQ0FBQSxNQUFELENBQVEsUUFBUixDQUFsQixFQUFxQyxJQUFDLENBQUEsU0FBdEMsQ0FBWjtXQUNBLENBQUEsQ0FBRSxzQkFBRixDQUF5QixDQUFDLE1BQTFCLENBQWlDLElBQUMsQ0FBQSxHQUFsQztFQUplOzt5QkFNakIsY0FBQSxHQUFnQixTQUFDLE1BQUQ7SUFDZCxDQUFBLENBQUUsc0JBQUYsQ0FBeUIsQ0FBQyxLQUExQixDQUFBO0lBQ0EsSUFBQyxDQUFBLGtCQUFELENBQW9CLG9CQUFwQixFQUEwQyxNQUExQztXQUNBLElBQUMsQ0FBQSxLQUFLLENBQUMsc0JBQVAsQ0FBOEIsTUFBOUIsRUFBc0MsSUFBQyxDQUFBLGVBQXZDO0VBSGM7O3lCQUtoQixrQkFBQSxHQUFtQixTQUFDLE9BQUQ7SUFDakIsQ0FBQSxDQUFFLE9BQUYsQ0FBVSxDQUFDLEtBQVgsQ0FBQTtXQUNBLE1BQU0sQ0FBQyxZQUFQLENBQW9CLENBQUEsQ0FBRSxPQUFGLENBQXBCO0VBRmlCOzt5QkFJbkIsa0JBQUEsR0FBbUIsU0FBQyxPQUFELEVBQVUsSUFBVjtJQUNqQixNQUFNLENBQUMsWUFBUCxDQUFvQixDQUFBLENBQUUsT0FBRixDQUFwQjtXQUNBLFlBQVksQ0FBQyxXQUFiLENBQXlCLENBQUEsQ0FBRSxPQUFGLENBQXpCLEVBQXFDLElBQXJDO0VBRmlCOzs7O0dBN0JNOztBQWlDM0IsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
